import React from "react"
import Navbar from "../components/NavBar"
import Education from "../components/Education"
import Footer from "../components/Footer"
import SEO from "../components/Seo"

export default function WhyEducationScreen() {
  return (
    <div>
      <SEO
        title="Education"
        description="Pendidikan merupakan faktor penting dalam pengembangan sumber daya manusia"
      />
      <Navbar color="blue" />
      <Education />
      <Footer />
    </div>
  )
}
